import { Fragment, ReactNode } from 'react';

export type EditorSectionDefinition = {
  id: string;
  content: ReactNode;
};

export function EditorSections({
  sections,
}: {
  sections: EditorSectionDefinition[];
}) {
  return (
    <div className="app-editor-sections">
      {sections.map(section => <Fragment key={section.id}>{section.content}</Fragment>)}
    </div>
  );
}
